// Centralized offer configuration — edit here to update the site content.
export const OFFER = {
  brand: "Quantum Results",
  tagline: "Change your thinking. Change your results.",
  logoUrl:
    "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/6sxe778m_logo-transparent-black-font.png",
  photoUrl:
    "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/64yoqcjq_Dan-Couch.png",
  creatorName: "Dan Hoover",

  offerTitle: "Four Levels Experience",
  priceUsd: 27,
  paymentLinkUrl: "https://buy.stripe.com/28E7sL45BbqQ9EGdKkfEk0T",

  // ── Public website copy (Website Copy v1.0) ─────────────────────────────
  hero: {
    headline:
      "Have you ever felt like you've changed… but your life hasn't fully caught up?",
    body:
      "Life has a way of changing us. We learn. We grow. Through our experiences, relationships, responsibilities, successes, disappointments, and quiet moments of reflection, we become someone different.\n\nYet there often comes a point when our outer life no longer feels like an accurate reflection of who we've become. You know you're capable of more. Not because you're trying to become someone else—but because you're ready for your life to reflect more of who you're capable of becoming.\n\nThe Four Levels is a guided one-hour experience designed to help you recognize a simple framework for understanding how we experience life and the results we create. It isn't about becoming someone new. It's about seeing yourself — and your life — from a new perspective.\n\nRecognition is often the beginning of meaningful change.",
    cta: "Begin the Four Levels Experience",
  },
  whatIsIt: {
    headline: "A simple framework for understanding how you experience life.",
    body:
      "The Four Levels is a guided one-hour experience designed to help you recognize a different way of understanding yourself, your choices, and the results you create.\n\nIt isn't a personality assessment. It isn't therapy. It isn't coaching. It isn't another online course filled with techniques to master.\n\nInstead, you'll be introduced to a simple framework that invites you to see your life from a different perspective. Sometimes one new perspective can explain years of experience. Sometimes it simply helps you ask better questions. Either way, recognition begins with seeing something you couldn't see before.",
    closing:
      "You don't need to prepare anything. Just bring an open mind and a willingness to reflect.",
  },
  whoFor: {
    headline: "Perhaps you'll recognize yourself here.",
    lines: [
      "You have a quiet sense that you're capable of more than you're currently experiencing.",
      "You've grown over the years, yet parts of your life still don't feel fully aligned with the person you've become.",
      "You value thoughtful reflection more than quick answers.",
      "You're open to seeing life — and yourself — from a different perspective.",
      "You don't expect someone else to have all the answers. But you're curious enough to ask better questions.",
    ],
    closing:
      "If that sounds like you, I believe you'll appreciate the Four Levels Experience.",
  },
  whatYouExperience: {
    headline: "A thoughtful experience you can complete in about an hour.",
    body:
      "The Four Levels Experience is designed to fit naturally into your life. Inside, you'll find six guided audio conversations that introduce the Four Levels framework one step at a time. You'll also receive a Recognition Guide to capture your thoughts, insights, and reflections as you move through the experience.\n\nThere are no deadlines. No assignments to submit. No pressure to finish in one sitting. You can listen at your own pace, pause whenever you like, and return whenever you're ready.\n\nMany people complete the experience in about an hour. Others choose to revisit the conversations over time as new insights emerge. Once you begin, you'll have lifetime access to everything.",
    closing:
      "This isn't about getting through the material. It's about giving yourself the space to notice what you've been ready to recognize.",
    included: [
      "Six guided audio conversations",
      "Your Recognition Guide",
      "Lifetime access",
      "Listen at your own pace",
    ],
  },
  meetDan: {
    headline: "A few words about me…",
    body:
      "Over the years, I've spent thousands of hours studying personal growth, human behavior, leadership, and the deeper questions that shape how we experience life. I've also lived through my own share of transitions, challenges, and moments that invited me to see life differently.\n\nAgain and again, I've discovered that meaningful change rarely begins with trying harder. It begins with seeing more clearly.\n\nThe Four Levels Experience grew out of that understanding. My hope is that these conversations give you the same opportunity they have given me — and many others — to pause, reflect, and recognize something that has been quietly waiting to be seen.",
    closing: "Thank you for allowing me to be part of your journey.",
    credentials: [
      "Founder, Quantum Results",
      "MBA, Kellogg School of Management, Northwestern University",
      "Author of Quantum Vibrations",
      "Executive Leadership & Mindset Coach",
      "Creator of the Four Levels Experience",
    ],
  },
  investment: {
    headline: "If you're ready, I'd be honored to guide you.",
    body:
      "The Four Levels Experience is available for a one-time investment of $27.",
    includes: [
      "Six guided audio conversations",
      "Your Recognition Guide",
      "Lifetime access to the experience",
      "The freedom to return whenever you'd like",
    ],
    closing:
      "There are no subscriptions. No ongoing commitments. Just a thoughtful hour that may leave you seeing yourself — and your life — a little differently.",
  },
  quietClosing:
    "Sometimes the smallest shift in how we see is the beginning of the biggest change in how we live.",

  // ── Version 2 paid-traffic landing copy (approved, USE AS WRITTEN) ─────
  // Governing document: 4-Levels-Experience-V2 Requirements Specification.
  // Do not rewrite. Minor line-break / typographic adjustments only.
  v2: {
    exp1: {
      eyebrow: "The Four Levels Experience",
      q1: "Why does this keep happening?",
      body1:
        "Maybe it's something in your career. A relationship. Your finances. Or simply a situation in your life that feels strangely familiar.\n\nWe usually respond by asking: \u201CWhat do I need to change?\u201D\n\nBut over the years, I've learned to ask another question first.",
      q2: "How am I experiencing what's happening?",
      body2:
        "Because two people can encounter remarkably similar circumstances\u2026 and experience them completely differently.\n\nWhat if understanding why begins there?",
    },
    exp2: {
      eyebrow: "A different question",
      headline: "What if the circumstances aren't the whole story?",
      body:
        "We naturally pay attention to what's happening around us. The job. The relationship. The money. The problem we wish would finally change.\n\nAnd those circumstances are real. But they may not be the only thing shaping our experience.\n\nBecause what happens in our lives\u2026 and how we experience what happens \u2026 aren't always the same thing.\n\nThere may be something underneath the circumstances that's easy to miss when we're focused only on changing them. A familiar way of seeing. A perspective we return to without even realizing it. A lens through which we interpret what's happening\u2014and decide what it means.\n\nOver time, that led me to a question that quietly changed the way I understood my own life:",
      question: "From what level am I experiencing my life?",
      closing:
        "For now, you don't need to know what I mean by \u201Clevel.\u201D Just think of it as your habitual way of seeing your life \u2014 the perspective your thoughts naturally return to\u2026 and the place from which you tend to respond.\n\nOnce you begin to recognize the perspective, you may begin to see the experience differently.",
    },
    exp3: {
      eyebrow: "The Four Levels",
      headline: "Four ways we can experience the same life.",
      intro:
        "Over time, I began to recognize four different perspectives from which we can experience and respond to life. I call them the Four Levels of Experience.",
      levels: [
        {
          name: "TO ME",
          essence: "Life is happening to me.",
          body:
            "This is the perspective we may recognize when circumstances seem to be holding the steering wheel. We find ourselves reacting, waiting, hoping something will change\u2014or wondering: \u201CWhy is this happening to me?\u201D",
        },
        {
          name: "BY ME",
          essence: "I can choose how I respond.",
          body:
            "Here, we begin to recognize our own ability to participate more fully in our lives. We take responsibility. We make decisions. We take action. Instead of waiting for something to change, we begin asking: \u201CWhat's mine to do?\u201D",
        },
        {
          name: "THROUGH ME",
          essence: "I don't have to force every outcome.",
          body:
            "We still take responsibility. We still make decisions and take action. But we begin to leave room for something more\u2014for ideas, opportunities, timing and possibilities we might miss when we're trying to control everything ourselves. The question begins to shift toward: \u201CWhat is Life inviting me to do?\u201D",
        },
        {
          name: "AS ME",
          essence: "A different way of responding begins to feel natural.",
          body:
            "Over time, something we've been intentionally practicing can begin to become simply the way we live. We may notice ourselves responding differently\u2026 recovering more quickly\u2026 trusting ourselves more deeply\u2026 without trying quite so hard to do it.",
        },
      ],
      closing:
        "These aren't four kinds of people. And they aren't a personality test, a scorecard or a ladder you're supposed to climb.\n\nYou may recognize different perspectives in different areas of your life. You may move between them as circumstances change. And none of this is about deciding where you should be.\n\nThe more interesting question is: Where do I recognize these perspectives in my own life?\n\nThat's what the Four Levels Experience is designed to help you explore.",
    },
    // Compact optional purchase invitation inserted between Experience 3
    // (the framework) and Experience 4 (What You'll Experience). Copy is
    // used verbatim as approved. This is an additional decision point;
    // it does not replace or modify the primary invitation at Experience 6.
    exp3b: {
      headline: "Ready to explore the Four Levels for yourself?",
      body:
        "The Four Levels Experience is a self-guided experience designed to help you recognize the perspective from which you're experiencing your life\u2014and begin to see what else may be available.",
      priceLine: "The Four Levels Experience \u2014 $27",
      cta: "Begin the Four Levels Experience",
      keepScrolling: "Prefer to learn more first? Keep scrolling.",
    },
    exp4: {
      eyebrow: "The Experience",
      headline: "This isn't a course to master. It's an experience to explore.",
      body:
        "The Four Levels Experience is a guided journey of listening, noticing and reflection.\n\nOver approximately one hour, I'll guide you through six audio conversations that introduce the Four Levels one perspective at a time. Along the way, your Recognition Guide gives you a place to pause and consider what you're noticing in your own life.\n\nYou won't be asked to memorize the framework. There are no right answers. Nothing is graded. And you don't need to decide which level you \u201Care.\u201D\n\nInstead, I'll invite you to notice what feels familiar. Where do you recognize the To Me perspective? Where might a By Me response already be available to you? When have you experienced something that felt more like Through Me? And where can you already see evidence that you're responding differently than you once would have?\n\nThe questions aren't designed to give you someone else's answers. They're designed to help you recognize your own.",
      receiveHeadline: "What you'll receive",
      receive: [
        {
          title: "6 guided audio conversations",
          body:
            "A thoughtful journey through the Four Levels and what each perspective can look and feel like in everyday life.",
        },
        {
          title: "Your companion Recognition Guide",
          body: "Simple reflection prompts to use as you move through the conversations.",
        },
        {
          title: "Approximately one hour",
          body:
            "Move through the complete experience at your own pace\u2014or pause and return whenever you'd like.",
        },
        {
          title: "Lifetime access",
          body:
            "Come back to the conversations and your Recognition Guide whenever another listen feels useful.",
        },
      ],
      closing:
        "You don't need to finish the experience understanding the Four Levels perfectly. My hope is much simpler:\n\nThat you understand yourself a little better than you did before.",
    },
    exp5: {
      eyebrow: "Why I created the Four Levels",
      headline: "For years, I thought growth meant doing more.",
      body:
        "I've spent much of my life interested in personal development. I've read hundreds of books. I've attended seminars, listened to remarkable teachers, and explored everything from psychology and human behavior to spirituality, success principles, neuroscience and quantum theory.\n\nAnd I learned something valuable from all of it. More importantly, I applied what I learned. I took responsibility. I set goals. I made decisions. I worked hard. And to be fair\u2026 a lot of it worked. My life changed in meaningful ways.\n\nBut somewhere along the way, I began asking a question I hadn't expected: Is doing more the only way we grow?\n\nI had learned how to create results. How to solve problems. How to make things happen. But I also began to recognize how much I was carrying. Every goal. Every decision. Every problem. Every outcome. It began to make me curious. What if there were other ways to experience life without giving up the responsibility, discipline and action that had served me so well?\n\nOver time, I began noticing something else. Two people could read the same book. Attend the same seminar. Hear the same idea. And walk away to create very different experiences of life. If information alone created the difference, why didn't it create similar results?\n\nThat question stayed with me. And eventually it led me back to the question you've already encountered on this page: From what level am I experiencing my life?\n\nThe Four Levels grew out of my attempt to understand that question. Not as a theory about how anyone else should live. But as a framework that helped me recognize something about the way I was experiencing my own life.\n\nAnd that's why I created this experience. Not to tell you who you are. To give you the opportunity to notice for yourself.",
      signature: "\u2014 Dan Hoover",
    },
    exp6: {
      eyebrow: "The Four Levels Experience",
      headline: "Give yourself an hour to notice something you may not have noticed before.",
      body:
        "If something you've read here has felt familiar\u2026 if you've found yourself wondering where these perspectives might be showing up in your own life\u2026 I created the Four Levels Experience to help you explore that question for yourself.\n\nYou'll move through six guided audio conversations, using your Recognition Guide along the way to pause, reflect and notice what feels true for you.\n\nThe purpose isn't to tell you which level you are. It isn't to give you another system you have to master. It's simply an opportunity to become more aware of the perspective from which you may be experiencing your life\u2014and to recognize that another perspective may be available.",
      offerLabel: "The Four Levels Experience",
      includes: [
        "6 guided audio conversations",
        "Companion Recognition Guide",
        "Approximately one hour",
        "Move at your own pace",
        "Lifetime access",
      ],
      price: "$27",
      priceNote: "One-time purchase. No subscription.",
      cta: "Begin the Four Levels Experience",
      reassurance: "You'll receive immediate access after your purchase.",
    },
    exp7: {
      headline: "Recognition comes before change.",
      body:
        "You don't have to change everything today. Sometimes the first step is simply noticing more clearly how you're experiencing what's already here.\n\nAnd once you can see something more clearly\u2026 another choice may become available.",
    },
  },

  // ── Private post-purchase experience (Experience Copy v1.0) ─────────────
  welcome: {
    headline: "Welcome. I'm glad you're here.",
    body:
      "Thank you for choosing to spend this time with me. Before you begin, I'd like to offer one simple suggestion. Slow down.\n\nThis isn't something you need to memorize or master. It's simply an opportunity to explore a different way of understanding how you experience life.\n\nAs you listen, notice what resonates with you. Pause whenever you'd like. Write down anything that feels meaningful in your Recognition Guide.\n\nThere is no right pace. Some people complete the experience in about an hour. Others return to the conversations over several days. Both approaches are equally valuable.\n\nWhen you're ready, begin with Conversation One.",
  },
  completion: {
    headline: "You've completed the Four Levels Experience.",
    body:
      "Thank you for allowing me to spend this time with you. I hope these conversations have given you a new perspective on yourself, your choices, and the way you experience life.\n\nRecognition is powerful. Not because it instantly changes everything. But because it's often the beginning of meaningful change.\n\nMy encouragement is simple. Don't rush to replace these ideas with new ones. Spend a little time noticing how this new perspective begins to influence the way you move through your everyday life.\n\nSometimes the greatest insights continue unfolding long after the conversations have ended.",
  },
  continueJourney: {
    // Post-completion invitation — a single, warm, non-salesy path back
    // to Dan. Links to the dedicated Four Levels Calendly event.
    headline: "Continue the Conversation",
    body:
      "If your experience raised questions, sparked new insights, or you'd simply appreciate a personal conversation, I'd be happy to talk with you. Sometimes a single conversation creates clarity that's difficult to find alone.",
    cta: "Schedule a Conversation with Dan",
    url: "https://calendly.com/hooverdan56/let-s-begin-with-a-conversation-clone",
    closing:
      "Thank you again for allowing me to be part of your journey. I genuinely hope these conversations continue to serve you well.\n— Dan Hoover",
  },

  // ── Deliverables ─────────────────────────────────────────────────────────
  files: {
    workbook:
      "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/4cstfrgg_Your%20Recognition%20Guide.pdf",
  },
  audioTracks: [
    {
      title: "Conversation One",
      subtitle: "The Four Levels of Awareness",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/a8c0u92h_Conversation-1.mp3",
    },
    {
      title: "Conversation Two",
      subtitle: "The To-Me Level",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/6dtjvsyw_Conversation-2.mp3",
    },
    {
      title: "Conversation Three",
      subtitle: "The By-Me Level",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/h0i75hjh_Conversation-3.mp3",
    },
    {
      title: "Conversation Four",
      subtitle: "The Through-Me Level",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/81qv7ffq_Conversation-4.mp3",
    },
    {
      title: "Conversation Five",
      subtitle: "The As-Me Level",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/34925k58_Conversation-5.mp3",
    },
    {
      title: "Conversation Six",
      subtitle: "Living with Greater Awareness",
      src: "https://customer-assets-jai6qajn.emergentagent.net/job_paywall-hub-1/artifacts/29c1rpb9_Conversation-6.mp3",
    },
  ],
};
